export function getTodayLocalDate(date = new Date()) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

export function getStartOfToday(date = new Date()) {
  const start = new Date(date);
  start.setHours(0, 0, 0, 0);
  return start;
}

export function isReservationUpcoming(reservedAt, now = new Date()) {
  if (!reservedAt) return false;
  return new Date(reservedAt) >= getStartOfToday(now);
}

export function filterUpcomingReservations(reservations, now = new Date()) {
  return (Array.isArray(reservations) ? reservations : [])
    .filter((reservation) => isReservationUpcoming(reservation.reserved_at, now));
}
